/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_IntegrationInputs */

const en_nav_integration = /** @type {(inputs: Nav_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integration errors`)
};

/**
* | output |
* | --- |
* | "Integration errors" |
*
* @param {Nav_IntegrationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_integration = /** @type {((inputs?: Nav_IntegrationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_IntegrationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_integration(inputs)
});